var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.514 9.326A4.79 4.79 0 0 0 10 10a4.79 4.79 0 0 0 2.485-.674 5.082 5.082 0 0 0 1.811-1.811 4.79 4.79 0 0 0 .674-2.485 4.95 4.95 0 0 0-.674-2.515A5.01 5.01 0 0 0 12.485.673 4.79 4.79 0 0 0 10 0a4.79 4.79 0 0 0-2.486.673 5.01 5.01 0 0 0-1.811 1.842 4.949 4.949 0 0 0-.674 2.515c0 .898.225 1.726.674 2.485a5.082 5.082 0 0 0 1.811 1.811zm6.558 3.728c-1.477-.36-2.834-.539-4.072-.539-1.237 0-2.595.18-4.072.54-1.676.418-3.034.977-4.072 1.676C.62 15.549 0 16.467 0 17.485V20h20v-2.515c0-1.018-.618-1.936-1.856-2.754-1.038-.699-2.395-1.258-4.072-1.677z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeWhite);
export default __webpack_public_path__ + "static/media/me_white.9a365601a627e8d0e7555dffa115829a.svg";
export { ForwardRef as ReactComponent };